import React, { useEffect, useState } from "react";
import { api, rupiah } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Building2, TrendingUp, Users, ShoppingBag, Loader2 } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <Card className="p-5 border-slate-200 rounded-xl shadow-sm" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm text-muted-foreground">{label}</span>
      <div className="w-9 h-9 rounded-lg bg-accent text-primary flex items-center justify-center"><Icon className="w-4 h-4" /></div>
    </div>
    <div className="mt-3 font-heading text-2xl font-bold tracking-tight">{value}</div>
  </Card>
);

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>;

  const statusRows = [
    { key: "active", label: "Aktif", cls: "bg-emerald-500" },
    { key: "due", label: "Jatuh Tempo", cls: "bg-amber-500" },
    { key: "expired", label: "Expired", cls: "bg-red-500" },
  ];
  const planRows = [
    { key: "basic", label: "Basic" }, { key: "pro", label: "Pro" }, { key: "premium", label: "Premium" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-overview-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Ringkasan Platform</h1>
        <p className="text-muted-foreground text-sm mt-1">Statistik seluruh toko pelanggan KASIRKU.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Building2} label="Total Toko" value={stats.total_tenants} testid="admin-total-tenants" />
        <Stat icon={TrendingUp} label="MRR (Simulasi)" value={rupiah(stats.mrr)} testid="admin-mrr" />
        <Stat icon={Users} label="Total Pengguna" value={stats.total_users} testid="admin-users" />
        <Stat icon={ShoppingBag} label="Total Transaksi" value={stats.total_transactions} testid="admin-txns" />
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        <Card className="p-5 border-slate-200 rounded-xl shadow-sm">
          <h3 className="font-heading font-bold">Status Langganan</h3>
          <div className="mt-4 space-y-3">
            {statusRows.map((r) => {
              const val = stats.by_status[r.key] || 0;
              const pct = stats.total_tenants ? (val / stats.total_tenants) * 100 : 0;
              return (
                <div key={r.key}>
                  <div className="flex justify-between text-sm mb-1"><span>{r.label}</span><span className="font-semibold">{val} toko</span></div>
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full ${r.cls} rounded-full`} style={{ width: `${pct}%` }} /></div>
                </div>
              );
            })}
          </div>
        </Card>

        <Card className="p-5 border-slate-200 rounded-xl shadow-sm">
          <h3 className="font-heading font-bold">Distribusi Paket</h3>
          <div className="mt-4 grid grid-cols-3 gap-3">
            {planRows.map((r) => (
              <div key={r.key} className="text-center p-4 rounded-xl bg-slate-50 border border-slate-100">
                <div className="font-heading text-2xl font-extrabold text-primary">{stats.by_plan[r.key] || 0}</div>
                <div className="text-xs text-muted-foreground mt-1">{r.label}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
